import { IUtilityService } from './IUtilityService';
import { of as observableOf, Observable } from 'rxjs';
import { HttpRequestService } from '../../http-request.service';
import { apiURLs, TransactionType, UnitType, SendVia, dateFormate } from '../../../globalcontants';
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EatecPreferenceSettings } from '../../../models/Application/EatecSettingsEntity';
import moment from 'moment-timezone';

@Injectable({
  providedIn: 'root'
})
export class UtilityService implements IUtilityService {
  constructor(private httpService: HttpRequestService) {
  }

  requisitionPostInput: any = {
    'TransTypeId': TransactionType.Requisition,
    'RequisitionHeaderDetail': {
      'InventoryHeadDetail': {
        'ReqOrTransHeaderId': 0,
        'RefNumber': '',
        'PostDate': moment().startOf('day').format(),
        'FromLocationId': 0,
        'ToLocationId': 0,
        'TotalAmount': 0,
        'Remarks': '',
        'DropShip': false,
        'PickedOrApprovedBy': '',
        'History': '',
        'LongRemarks': '',
        'DebitDeptId': 0,
        'DataMagineNumber': '',
        'DeviceId': ''
      },
      'CustomerId': 0,
      'EventId': 0,
      'DaySequenceId': 0,
      'Priority': 0,
      'Processed': 0,
      'GroupNum': 0,
      'DeliveryDock': 0,
      'DeliveryTime': moment().startOf('day').format(),
      'PlanId': 0,
      'RevNumber': 0,
      'PlanLocationId': 0,
      'ApprovalStatusId': 0,
      'POUser': 0,
      'SetupHeaderDetail': {
        'miscflag': '                                                                                                                                ',
        'LoadedReq': 0,
        'TransToRev': 0,
        'Approval': 0,
        'Approver': 0,
        'NextApprover': 0,
        'NextApproverId': '',
        'ApprovalStatusId': ''
      }
    },
    'CreatedBy': '',
    'CreatedDate': moment().utc().format(),
    'EatecEntity': 1,
    'UserId': 0,
    'ReqLocakedByMe': 0,
    'ImageId': 43223647,
    'RequisitionItemDetails': [
      {
        'ItemDetailId': 0,
        'InventoryItemDetail': {
          'ReqOrTransHeaderId': 0,
          'InventoryId': 0,
          'UnitId': 0,
          'Quantity': 0,
          'Conversion': 0,
          'TotalAmount': 0,
          'FromLocationId': 0,
          'ToLocationId': 0,
          'Remarks': '',
          'PostDate': moment().startOf('day').format(),
          'InventoryTypeId': 0
        },
        'InventoryDetail': {
          'Name': '',
          'Number': '',
          'Description': '',
          'BarCode': '',
          'UnitsDetails': [
            {
              'UnitId': 0,
              'UnitCode': '',
              'Conversion': 0,
              'UnitTypeId': UnitType.BaseUnit
            },
            {
              'UnitId': 0,
              'UnitCode': '',
              'Conversion': 0,
              'UnitTypeId': UnitType.PurchaseUnit
            },
            {
              'UnitId': 0,
              'UnitCode': '',
              'Conversion': 0,
              'UnitTypeId': UnitType.TransactionUnit
            },
            {
              'UnitId': 0,
              'UnitCode': '',
              'Conversion': 0,
              'UnitTypeId': UnitType.RecipeUnit
            }
          ],
          'SelectedUnitDetail': {
            'UnitId': 0,
            'UnitCode': '',
            'Conversion': 0,
            'UnitTypeId': 0
          },
          'LocationDetail': {
            'LocationName': ''
          },
          'InventoryOtherDetail': {
            'ProdRecipeId': 0,
            'RevenueGrouping': 0,
            'AliasRevenueGrouping': 0,
            'InventoryId': 0,
            'AliasUnitId': 0,
            'AliasConversion': 0.0
          },
          'CurrentCost': 0.0,
          'InventoryPeriodicDetail': {
            'CurrentCost': 0.0,
            'AliasCurrentCost': 0.0,
            'QuantityOnHand': 0.0
          },
          'SetupHeaderDetail': {
            'Quantity': 0.0,
            'AliasQuantity1': 0.0,
            'AliasQuantity2': 0.0,
            'AliasQuantity3': 0.0,
            'ItemId': 0,
            'Text01': 'N',
            'Remarks': '',
            'Position': 1,
            'LinkDB': 1,
            'AliasText01': '',
            'AliasRemarks': '',
            'SupplyLocQty': 0.0,
            'AliasSupplyLocQty': 0.0
          },
          'InventoryTypeId': 0,
          'InventoryId': 0,
          'InventoryClassId': 0,
          'InventoryStatusByLocationDetail': {
            'QtyOnHand': 0.0,
            'MinPar': 0.0,
            'MaxPar': 0.0,
            'CurrentCost': 0.0,
            'QtyOnReq': 0.0,
            'QtyOnOrder': 0.0
          },
          'InventoryTypeDetail': {
            'TypeName': ''
          },
          'PictureVideoDetails': [
            {
              'FilePath': ''
            }
          ]
        }
      }
    ]
  };

  transfersPostInput: any = {
    'TransTypeId': TransactionType.Transfer,
    'TransferHeadDetail': {
      'InventoryHeadDetail': {
        'ReqOrTransHeaderId': 0,
        'RefNumber': '',
        'PostDate': moment().startOf('day').format(),
        'FromLocationId': 0,
        'ToLocationId': 0,
        'TotalAmount': 0,
        'ReqNo': 0,
        'CustomerId': 0,
        'Remarks': '',
        'PickedOrApprovedBy': '',
        'LongRemarks': '',
        'DebitDeptId': 0,
        'DataMagineNumber': '',
        'LocationDetail': {
          'LocationId': 0,
          'LocationName': '',
          'SupplyLocationId': 0,
          'SupplyLocationName': '',
        },
      },
      'SetupHeaderDetail': {
        'Miscflag': '',
        'LoadedReq': 0,
        'TransToRev': 0,
        'Approval': 0,
        'Approver': 0,
        'NextApprover': 0,
        'NextApproverId': '',
        'ApprovalStatusId': '',
      },
      'DebitAccId': 0,
      'Misc1': '',
      'Misc2': '',
    },
    'CreatedBy': '',
    'CreatedDate': moment().utc().format(),
    'EatecEntity': 1,
    'UserId': 0,
    'ReqLocakedByMe': 0,
    'ImageId': 43223647,
    'TransferItemDetails': [
      {
        'ItemDetailId': 0,
        'InventoryItemDetail': {
          'ReqOrTransHeaderId': 0,
          'InventoryId': 0,
          'UnitId': 0,
          'Quantity': 0,
          'Conversion': 0,
          'TotalAmount': 0,
          'FromLocationId': 0,
          'ToLocationId': 0,
          'Remarks': '',
          'PostDate': moment().startOf('day').format(),
          'InventoryTypeId': 0
        },
        'SelectedUnitDetail': {
          'UnitId': 0,
          'UnitCode': '',
          'Conversion': 0,
          'UnitTypeId': 0
        },
        'InventoryDetail': {
          'Name': '',
          'Number': '',
          'Description': '',
          'UnitsDetails': [
            {
              'UnitId': 0,
              'UnitCode': '',
              'Conversion': 1,
              'UnitTypeId': UnitType.BaseUnit
            },
            {
              'UnitId': 0,
              'UnitCode': '',
              'Conversion': 0,
              'UnitTypeId': UnitType.PurchaseUnit
            },
            {
              'UnitId': 0,
              'UnitCode': '',
              'Conversion': 0,
              'UnitTypeId': UnitType.TransactionUnit,
            },
            {
              'UnitId': 0,
              'UnitCode': '',
              'Conversion': 0,
              'UnitTypeId': UnitType.RecipeUnit
            }
          ],
          'LocationDetail': {
            'LocationName': ''
          },
          'InventoryOtherDetail': {
            'ProdRecipeId': 0,
            'RevenueGrouping': 0,
            'CatchWeightFlag': 0
          },
          'CurrentCost': 0.0,
          'InventoryPeriodicDetail': {
            'CurrentCost': 0.0,
            'AliasCurrentCost': 0.0,
            'QuantityOnHand': 0.0
          },
          'SetupHeaderDetail': {
            'Quantity': 0.0,
            'LinkDB': 1,
            'Position': 1,
            'ItemId': 0,
            'Text01': 'N',
            'Remarks': '',
            'ProdBatch': '',
            'AliasQuantity1': 0.0,
            'AliasRemarks': '',
            'LocQty': 0,
            'AliasLocQty': 0,
            'SupplyLocQty': 0.0,
            'AliasSupplyLocQty': 0.0,
            'LotId': 0,
            'LotQty': 0,
            'LotName': ''
          },
          'InventoryTypeId': 0,
          'InventoryId': 0,
          'InventoryClassId': 0,
          'BarCode': '',
          'PictureVideoDetail': {
            'FilePath': ''
          }
        },
        'ReqNo': 0,
        'ProductionBatch': '',
        'ShippingCost': 0,
        'LotNum': 0,
      }
    ]
  };

  spoilagePostInput: any = {
    'TransTypeId': TransactionType.Spoilage,
    'SpoilageHeaderDetail': {
      'SpoilageHeaderId': 0,
      'RefNumber': '',
      'PostDate': moment().startOf('day').format(),
      'LocationId': 0,
      'TotalAmount': 0.0,
      'PlanIncidentNumber': '',
      'ApprovedBy': '',
      'Remarks': '',
      'EnteredOn': moment().utc().format(),
      'EnteredBy': '',
      'SourceId': 0,
      'PlanHeaderId': 0,
      'MealId': 0,
      'DataMagineNumber': '',
      'TransactionApprovalStatusId': 0,
      'TransactionPostingStatusId': 0,
      'DeviceId': '',
      'DebitDeptId': 0,
      'SetupHeaderDetail': {
        'Miscflag': '',
        'LoadedReq': 0,
        'TransToRev': 0,
        'Approval': 0,
        'Approver': 0,
        'NextApprover': 0,
        'NextApproverId': '',
        'ApprovalStatusId': '',
      },
    },
    'SpoilageItemDetails': [
      {
        'SpoilageDetailId': 0,
        'SpoilageHeaderId': 0,
        'InventoryId': 0,
        'SpoilageTypeId': 1,
        'UnitId': 0,
        'Quantity': 0.0,
        'Conversion': 0.0,
        'TotalAmount': 0.0,
        'LocationId': 0,
        'PostDate': moment().startOf('day').format(),
        'Remarks': '',
        'LotNumId': 0,
        'InventoryDetail': {
          'Name': '',
          'Number': '',
          'Description': '',
          'InventoryTypeId': 0,
          'InventoryClassId': 0,
          'UnitsDetails': [
            {
              'UnitId': 0,
              'UnitCode': '',
              'Conversion': 1.0,
              'UnitTypeId': UnitType.BaseUnit,
            },
            {
              'UnitId': 0,
              'UnitCode': '',
              'Conversion': 1.0,
              'UnitTypeId': UnitType.PurchaseUnit
            },
            {
              'UnitId': 0,
              'UnitCode': '',
              'Conversion': 1.0,
              'UnitTypeId': UnitType.TransactionUnit
            },
            {
              'UnitId': 0,
              'UnitCode': '',
              'Conversion': 1.0,
              'UnitTypeId': UnitType.RecipeUnit
            }
          ],
          'SelectedUnitDetail': {
            'UnitId': 0,
            'UnitCode': '',
            'Conversion': 0,
            'UnitTypeId': 0
          },
          'BarCode': '',
          'CurrentCost': 0.0,
          'UnitCost': 0.0,
          'LocationDetail': {
            'LocationName': ''
          },
          'InventoryOtherDetail': {
            'InventoryId': 0,
            'ProdRecipeId': 0,
            'RevenueGrouping': 0,
            'AliasInventoryId': 0
          },
          'InventoryPeriodicDetail': {
            'CurrentCost': 0.0,
            'QuantityOnHand': 0.0
          },
          'SetupHeaderDetail': {
            'Quantity': 0.0,
            'LinkDB': 1,
            'Position': 1,
            'Remarks': '',
            'Text01': 'N',
            'LotId': 0,
            'LotQty': 0.0,
            'AliasLotQty': 0.0,
            'LotName': ''
          }
        }
      }
    ],
    'EatecEntity': 1,
    'UserId': 0,
    'ReqLocakedByMe': 0,
    'ImageId': 43223647
  };

  docsPostInput: any = [
    {
      'TransApprovalId': 0,
      'IntNum': 0,
      'RefNumber': 0,
      'SourceId': 0,
      'TotalAmount': 0,
      'UserId': 0,
      'UserName': '',
      'EnteredOn': moment().utc().format(),
      'SourceDetail':
      {
        'SourceName': ''
      },
      'SetupHeaderDetail':
      {
        'ItemId': 0,
        'Remarks': ''
      }
    }

  ];

  poPostInput: any = {
    'TransTypeId': TransactionType.PurchaseOrder,
    'PurchaseOrderHead': {
      'HeaderId': 0,
      'RevisionNumber': 0,
      'Reference': '',
      'SourceReference': '',
      'DeliverTo': '',
      'Buyer': '',
      'Attention': '',
      'ShipVia': '',
      'Region': '',
      'Office': '',
      'Other3': '',
      'Other4': '',
      'Other5': '',
      'RecommendedSupplierId': 0,
      'PostDate': moment().startOf('day').format(),
      'RequestingLocationId': 0,
      'DivisionId': 0,
      'PoTotal': 0,
      'Valued': 0.0,
      'CurentApprovalLevel': 0,
      'JobNumber': 0,
      'InvoiceCurrency': 1,
      'EnteredOn': moment().utc().format(),
      'EnteredBy': '',
      'Remarks': '',
      'Memo': '',
      'History': '',
      'MiscTotal': '0|0|0|0|0|0|0|0|0|0|0|',
      'MarketListId': 0,
      'Position': 0,
      'GroupNumber': 0,
      'CancelDate': moment().utc().format(),
      'UnAssigned': '',
      'DepartmentId': 1,
      'Distro': 0,
      'CustomerId': 0,
      'SentVia': SendVia.Fax,
      'Remark1': '',
      'ApprovalStatus': 0,
      'Reason': '',
      'Sent': 0,
      'SentOn': moment().utc().format(),
      'Subject': 'PPO01.RPT',
      'SetupHeaderDetail': {
        'Approval': 0,
        'Approver': 0,
        'NextApprover': 0,
        'NextApproverId': '',
        'ApprovalStatusId': ''
      }
    },
    'PurchaseOrderDetail': [
      {
        'PODetailId': 0,
        'PoId': 0,
        'Unit': 0,
        'Conversion': 0.0,
        'CompanyId': 0,
        'LocationId': 0,
        'BidNumber': '',
        'PuchaseQuantity': 0.0,
        'Valued1': 0.0,
        'MiscAllocCharge': 0.0,
        'Remark': '',
        'Remark2': '',
        'Status': 0,
        'ReceivedQuantity': 0.0,
        'ValueReceived': 0.0,
        'ActualAllocCharge': 0.0,
        'SourceReference': '',
        'UnitName': '',
        'PostDate': moment().startOf('day').format(),
        'ContractId': 0,
        'Rebate': 0.0,
        'RevisionNumber': 0,
        'GroupReference': '',
        'ApprovedValue': 0.0,
        'PostDate1': moment().startOf('day').format(),
        'Misc1': '',
        'Misc2': '',
        'Misc3': '',
        'Misc4': '',
        'Misc5': '',
        'Currency': 0,
        'ValueFc': 0.0,
        'CurrencyRate': 0.0,
        'Tolerance': 0.0,
        'BidId': 0,
        'Bid2Id': 0,
        'TaxAmount1': 0.0,
        'TaxAmount2': 0.0,
        'LotNumber': 0,
        'InventoryDetail': {
          'InventoryId': 0,
          'Name': '',
          'Number': '',
          'Description': '',
          'InventoryTypeId': 0,
          'InventoryClassId': 0,
          'UnitsDetails': [
            {
              'UnitId': 0,
              'Conversion': 1.0,
              'UnitTypeId': 0
            },
            {
              'UnitId': 0,
              'Conversion': 0.0,
              'UnitTypeId': 1
            },
            {
              'UnitId': 0,
              'Conversion': 0.0,
              'UnitTypeId': 2
            },
            {
              'UnitId': 0,
              'Conversion': 0.0,
              'UnitTypeId': 3
            }
          ],
          'SelectedUnitDetail': {
            'Conversion': 0.0,
            'UnitCode': ''
          },
          'LocationDetail': {
            'LocationName': ''
          },
          'InventoryOtherDetail': {
            'InventoryId': 0,
            'AliasInventoryId': 0,
            'MinPar': 0.0,
            'MaxPar': 0.0,
            'RevenueGrouping': 0,
            'MiscText': '',
            'ProdRecipeId': 0,
            'Volume': 0.0
          },
          'SetupHeaderDetail': {
            'UnitCost': 0.0,
            'IUnitCost': 0.0,
            'AliasLotQty': 0.0,
            'Text01': 'N',
            'MarketListId': 0,
            'LinkDB': 1,
            'Position': 1,
            'RqIntNum': 0,
            'DbDept2': 0,
            'SupplierPrecision': '',
            'RqSource': 0,
            'SourceRef': '',
            'Text64': '',
            'Text12': '',
            'ItemId': 0,
            'RqaListId': 0,
            'AliasQuantity1': 0.0,
            'Attribute': ''
          },
          'InventoryTypeDetail': {
            'TaxRateId1': 0,
            'TaxRateId2': 0,
            'GratuityOnRecpt': 0,
            'DivisionId': 0,
            'GroupApprLvl': 0
          },
          'SupplierDetail': {
            'SupplierName': '',
            'LeadTime': ''
          },
          'MediaDetail': {
            'MediaName': '',
            'AliasMediaName': ''
          },
          'TaxRegionDetail': {
            'TaxOptionId': 0
          },
          'TaxRatesDetail': {
            'RegionId': 0,
            'TaxRate': 0.0,
            'TaxRate1': 0.0,
            'TaxRate2': 0.0
          }
        }
      }
    ],
    'PoNum': 0,
    'PoMode': 1,
    'Message': '',
    'EatecEntity': 1,
    'UserId': 1
  };

  messagePostInput: any =

    {
      'RecipientList': [],
      'MessageHeadDetail': {
        'MessageId': 0,
        'StatusId': 0
      },
      'MessageItemDetails': {
        'Source': 'string',
        'Remark': 'string',
        'FunctionNumber': 0,
        'FunctionReference': 0,
        'EnteredOn': '2019-01-09T10:34:28.674Z',
        'EnteredBy': 'string',
        'Message': 'string',
        'SourceSiteId': 0,
        'SenderId': 0
      }
    };

  CurrencyFormatter = new Intl.NumberFormat;
  CurrencyFormatterWithOutStyle = new Intl.NumberFormat;
  DecimalFormatter = new Intl.NumberFormat;
  DateFormatter = new Intl.DateTimeFormat;
  DateFormat = localStorage.hasOwnProperty(dateFormate.toString()) ? localStorage.getItem(dateFormate.toString()) : 'MM/DD/YYYY';
  EatecPreferenceSettings: EatecPreferenceSettings;
  CurrencyCode = 'USD';
  currncyMaximumFractionDigits = 4;

}
